
export const transformProductsData = (raw) => {
  const groups = raw.product_groups || raw;

  const sections = [];

  Object.entries(groups).forEach(([sectorKey, sectorData]) => {
    const sectorName =
      sectorData.sector_name ||
      sectorKey
        .split('_')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');

    const slides = Object.entries(sectorData)
      .filter(([key]) => key !== 'sector_name')
      .map(([, product], index) => {
        const img = product.product_image;
        let imageUrl = null;
        let imageAlt = '';

        if (img && typeof img === 'object') {
          imageUrl = img.sizes?.large || img.url || null;
          imageAlt = img.alt || '';
        } else if (typeof img === 'string' && img) {
          imageUrl = img;
        }

        const slug = product.product_name
          ? product.product_name.toLowerCase().replace(/\s+/g, '-')
          : '';

        return {
          tag: `${sectorName.toUpperCase()} · ${String(index + 1).padStart(2, '0')}`,
          title: product.product_name,
          description: product.product_description,
          slug,
          imageUrl,
          imageAlt,
        };
      });

    sections.push({
      key: sectorKey,
      label: sectorName.toUpperCase(),
      name: sectorName,
      slides,
    });
  });

  return sections;
};

/**
 * Parse ACF fields from a product detail page.
 *
 * ACF shape:
 * {
 *   "<product_key>": {
 *     product_sector, product_name, product_details, product_image,
 *     section_1: { section_name, feature_1, feature_2, ... },
 *     section_2: { section_name, feature_1, feature_2, ... },
 *     ...
 *   }
 * }
 *
 * Sections (section_*) and features (feature_*) are dynamic.
 */
export const transformProductDetails = (acf) => {
  const productKey = Object.keys(acf).find(
    (k) => typeof acf[k] === 'object' && acf[k]?.product_name
  );
  if (!productKey) return null;

  const p = acf[productKey];

  // Parse product image
  const img = p.product_image;
  let imageUrl = null;
  if (img && typeof img === 'object') {
    imageUrl = img.sizes?.large || img.url || null;
  } else if (typeof img === 'string' && img) {
    imageUrl = img;
  }

  // Collect dynamic sections (section_1, section_2, ...)
  const sections = Object.keys(p)
    .filter((k) => /^section_\d+$/.test(k) && typeof p[k] === 'object')
    .sort()
    .map((sectionKey) => {
      const section = p[sectionKey];
      const name = section.section_name || sectionKey;

      // Collect dynamic features (feature_1, feature_2, ...)
      const features = Object.keys(section)
        .filter((k) => /^feature_\d+$/.test(k) && typeof section[k] === 'string' && section[k])
        .sort()
        .map((featureKey) => {
          const v = section[featureKey];
          const idx = v.indexOf(':');
          if (idx > -1) {
            return { title: v.slice(0, idx).trim(), desc: v.slice(idx + 1).trim() };
          }
          return { title: v, desc: '' };
        });

      return { name, features };
    });

  return {
    name: p.product_name || '',
    sector: p.product_sector || '',
    description: p.product_details || '',
    imageUrl,
    sections,
  };
};
